import { createAuthClient } from "better-auth/react";

// Same-origin: Pages Functions mount the better-auth handler at /api/auth
// (see server/http/app.ts), matching the client's default basePath.
export const authClient = createAuthClient({
  basePath: "/api/auth"
});
